import { apiService } from './apiService';

export interface IColor {
  _id: string;
  name: string;
  hexCode?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const colorApi = {
  // Get all colors
  getColors: async (): Promise<IColor[]> => {
    try {
      const response = await apiService.get('/colors');
      return response.data?.colors || [];
    } catch (error: any) {
      console.error('Error fetching colors:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch colors');
    }
  },

  // Get color by ID
  getColorById: async (colorId: string): Promise<IColor> => {
    try {
      const response = await apiService.get(`/colors/${colorId}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching color:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch color');
    }
  }
};
